import './Page.css'
import React from "react";

export default function ContentWMax({ bg = 'transparent', children }) {
    return (
        <div className='pl-l pr-l content-wmax' style={{ backgroundColor: bg }}>
            {children}
        </div>
    )
}
